export var COOKIE_NAME_RNDINSIDER_BEARERTOKEN = 'rndinsider-bearer'